/**
 * Atomic document number generation via Firestore transactions.
 * Falls back to in-memory counter when Firebase is not configured.
 */
import { db, isConfigured } from './config';
import { doc, runTransaction } from 'firebase/firestore';

const localCounters = {
  WC: 10850, QT: 10080, RC: 10010, BOL: 20010,
  INV: 30010, AST: 100, TRK: 100, 'TRK-PLT': 100, EXC: 40031,
  PO: 20041, APT: 30051, PMT: 30081, CM: 30081,
};

export async function getNextDocNumber(prefix) {
  const padLen = prefix === 'TRK-PLT' ? 5 : 5;

  if (isConfigured && db) {
    const counterRef = doc(db, 'counters', prefix);
    const result = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      let next = 1;
      if (counterDoc.exists()) {
        next = (counterDoc.data().current || 0) + 1;
      }
      transaction.set(counterRef, { current: next, prefix, updatedAt: new Date() });
      return next;
    });
    return `${prefix}-${String(result).padStart(padLen, '0')}`;
  }

  // Local fallback (not collision-safe — dev only)
  const current = localCounters[prefix] || 1;
  localCounters[prefix] = current + 1;
  return `${prefix}-${String(current).padStart(padLen, '0')}`;
}
